var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManBuildingRelax(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_206_2397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 260,
    height: 260
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260 0H0V260H260V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_206_2397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.663 312.894V170.72H235.793V331.531",
    stroke: "#DED794",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.138 183.82V192.14H185.458V176.87H177.138V183.82ZM178.505 178.235H184.08V183.82H178.505V178.235ZM178.505 185.185H184.08V190.77H178.505V185.185Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.807 183.82V192.14H200.127V176.87H191.807V183.82ZM193.179 178.238H198.764V183.82H193.179V178.238ZM193.179 185.188H198.764V190.772H193.179V185.188Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.075 183.82V192.14H214.395V176.87H206.075V183.82ZM207.443 178.235H213.028V183.82H207.443V178.235ZM207.443 185.185H213.028V190.77H207.443V185.185Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.507 176.87V192.14H227.827V176.87H219.507ZM226.459 190.772H220.872V185.188H226.459V190.772ZM226.459 183.82H220.872V178.238H226.459V183.82Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.138 204.359V212.679H185.458V197.412H177.138V204.359ZM178.505 198.774H184.08V204.359H178.505V198.774ZM178.505 205.724H184.08V211.309H178.505V205.724Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.807 204.359V212.679H200.127V197.412H191.807V204.359ZM193.179 198.777H198.764V204.359H193.179V198.777ZM193.179 205.727H198.764V211.312H193.179V205.727Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.075 204.359V212.679H214.395V197.412H206.075V204.359ZM207.443 198.774H213.028V204.359H207.443V198.774ZM207.443 205.724H213.028V211.309H207.443V205.724Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.507 204.359V212.679H227.827V197.412H219.507V204.359ZM220.872 198.774H226.459V204.359H220.872V198.774ZM220.872 205.724H226.459V211.309H220.872V205.724Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.138 224.899V233.219H185.458V217.952H177.138V224.899ZM178.505 219.314H184.08V224.899H178.505V219.314ZM178.505 226.267H184.08V231.852H178.505V226.267Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.807 224.899V233.219H200.127V217.952H191.807V224.899ZM193.179 219.317H198.764V224.899H193.179V219.317ZM193.179 226.269H198.764V231.854H193.179V226.269Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.075 224.899V233.219H214.395V217.952H206.075V224.899ZM207.443 219.314H213.028V224.899H207.443V219.314ZM207.443 226.267H213.028V231.852H207.443V226.267Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.507 224.899V233.219H227.827V217.952H219.507V224.899ZM220.872 219.314H226.459V224.899H220.872V219.314ZM220.872 226.267H226.459V231.852H220.872V226.267Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.138 245.439V253.759H185.458V238.492H177.138V245.439ZM178.505 239.854H184.08V245.439H178.505V239.854ZM178.505 246.804H184.08V252.389H178.505V246.804Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.807 245.439V253.759H200.127V238.492H191.807V245.439ZM193.179 239.86H198.764V245.439H193.179V239.86ZM193.179 246.809H198.764V252.394H193.179V246.809Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.075 245.439V253.759H214.395V238.492H206.075V245.439ZM207.443 239.854H213.028V245.439H207.443V239.854ZM207.443 246.804H213.028V252.389H207.443V246.804Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.507 245.439V253.759H227.827V238.492H219.507V245.439ZM220.872 239.854H226.459V245.439H220.872V239.854ZM220.872 246.804H226.459V252.389H220.872V246.804Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.138 265.98V274.3H185.458V259.032H177.138V265.98ZM178.505 260.395H184.08V265.98H178.505V260.395ZM178.505 267.345H184.08V272.93H178.505V267.345Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.807 265.98V274.3H200.127V259.032H191.807V265.98ZM193.174 260.395H198.759V265.98H193.179L193.174 260.395ZM193.174 267.345H198.759V272.93H193.179L193.174 267.345Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.075 265.98V274.3H214.395V259.032H206.075V265.98ZM207.443 260.395H213.028V265.98H207.443V260.395ZM207.443 267.345H213.028V272.93H207.443V267.345Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.507 265.98V274.3H227.827V259.032H219.507V265.98ZM220.872 260.395H226.459V265.98H220.872V260.395ZM220.872 267.345H226.459V272.93H220.872V267.345Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.018 112.775V41.6569H200.145V170.726",
    stroke: "#DED794",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.491 54.7557V63.0757H149.811V47.8033H141.491V54.7557ZM142.859 49.1709H148.444V54.7557H142.859V49.1709ZM142.859 56.1207H148.444V61.7055H142.859V56.1207Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.163 54.7557V63.0757H164.483V47.8033H156.163V54.7557ZM157.528 49.1709H163.113V54.7557H157.528V49.1709ZM157.528 56.1207H163.113V61.7055H157.528V56.1207Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.433 54.7557V63.0757H178.753V47.8033H170.433V54.7557ZM171.798 49.1709H177.382V54.7557H171.798V49.1709ZM171.798 56.1207H177.382V61.7055H171.798V56.1207Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.861 47.8033V63.0705H192.181V47.8033H183.861ZM190.811 61.7055H185.229V56.1207H190.811V61.7055ZM190.811 54.7557H185.229V49.1709H190.811V54.7557Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.491 75.2952V83.6152H149.811V68.3454H141.491V75.2952ZM142.859 69.7104H148.444V75.2952H142.859V69.7104ZM142.859 76.6602H148.444V82.245H142.859V76.6602Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.163 75.2952V83.6152H164.483V68.3454H156.163V75.2952ZM157.528 69.7104H163.113V75.2952H157.528V69.7104ZM157.528 76.6602H163.113V82.245H157.528V76.6602Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.433 75.2952V83.6152H178.753V68.3454H170.433V75.2952ZM171.798 69.7104H177.382V75.2952H171.798V69.7104ZM171.798 76.6602H177.382V82.245H171.798V76.6602Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.861 75.2952V83.6152H192.181V68.3454H183.861V75.2952ZM185.229 69.7104H190.811V75.2952H185.229V69.7104ZM185.229 76.6602H190.811V82.245H185.229V76.6602Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.491 95.8352V104.155H149.811V88.8854H141.491V95.8352ZM142.859 90.2504H148.444V95.8352H142.859V90.2504ZM142.859 97.2028H148.444V102.788H142.859V97.2028Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.163 95.8352V104.155H164.483V88.8854H156.163V95.8352ZM157.528 90.2504H163.113V95.8352H157.528V90.2504ZM157.528 97.2028H163.113V102.788H157.528V97.2028Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.433 95.8352V104.155H178.753V88.8854H170.433V95.8352ZM171.798 90.2504H177.382V95.8352H171.798V90.2504ZM171.798 97.2028H177.382V102.788H171.798V97.2028Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.861 95.8352V104.155H192.181V88.8854H183.861V95.8352ZM185.229 90.2504H190.811V95.8352H185.229V90.2504ZM185.229 97.2028H190.811V102.788H185.229V97.2028Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.491 116.378V124.698H149.811V109.425H141.491V116.378ZM142.859 110.793H148.444V116.378H142.859V110.793ZM142.859 117.743H148.444V123.328H142.859V117.743Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.163 116.378V124.698H164.483V109.425H156.163V116.378ZM157.528 110.793H163.113V116.378H157.528V110.793ZM157.528 117.743H163.113V123.328H157.528V117.743Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.433 116.378V124.698H178.753V109.425H170.433V116.378ZM171.798 110.793H177.382V116.378H171.798V110.793ZM171.798 117.743H177.382V123.328H171.798V117.743Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.861 116.378V124.698H192.181V109.425H183.861V116.378ZM185.229 110.793H190.811V116.378H185.229V110.793ZM185.229 117.743H190.811V123.328H185.229V117.743Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.163 136.918V145.238H164.483V129.965H156.163V136.918ZM157.528 131.333H163.113V136.918H157.528V131.333ZM157.528 138.283H163.113V143.868H157.528V138.283Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.433 136.918V145.238H178.753V129.965H170.433V136.918ZM171.798 131.333H177.382V136.918H171.798V131.333ZM171.798 138.283H177.382V143.868H171.798V138.283Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.861 136.918V145.238H192.181V129.965H183.861V136.918ZM185.229 131.333H190.811V136.918H185.229V131.333ZM185.229 138.283H190.811V143.868H185.229V138.283Z",
    fill: "#DED794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5361 99.0595C67.6361 90.6407 64.7371 81.7877 62.2905 72.8463C55.6111 48.4297 70.4207 19.5203 95.9579 14.1669C104.634 12.3469 113.674 12.7837 122.317 14.5699C136.593 17.5157 149.279 27.6531 156.442 40.3437C160.053 46.7397 162.336 53.9443 162.588 61.3101C162.892 70.1657 158.662 77.6771 157.323 86.2545L157.276 86.5405",
    stroke: "#DED794",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.893 246.958C157.082 247.091 158.702 246.849 157.893 246.958ZM157.893 246.958C183.82 247 203.687 227.008 200.46 198.258C197.416 171.181 181.881 152.999 164.125 134.742C156.302 126.698 150.428 107.055 155.823 99.9385",
    stroke: "#DED794",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6689 143.127C58.6689 143.679 58.6871 144.23 58.7027 144.771C59.0199 154.44 61.3157 160.797 62.7015 163.8C62.2478 162.518 62.0913 161.15 62.2439 159.799C62.3414 158.882 62.4863 157.971 62.6781 157.069C63.7675 152.007 66.2388 147.347 69.8177 143.606L69.8515 143.575C70.3273 143.081 70.6939 142.748 70.8915 142.571L70.9799 142.48L71.0709 142.407L111.394 104.044C111.646 102.393 111.806 100.729 111.873 99.06C113.901 99.3694 116.121 99.6034 118.552 99.762C120.463 99.879 122.52 99.9466 124.706 99.9544C144.807 100.022 153.442 103.126 156.79 104.957C156.982 105.062 157.198 105.116 157.417 105.113C157.636 105.11 157.851 105.05 158.039 104.939C158.228 104.827 158.384 104.669 158.493 104.479C158.602 104.289 158.659 104.073 158.66 103.854V87.1858C156.32 85.9248 153.434 85.0486 149.859 84.7392C140.205 83.9046 129.6 83.9592 120.549 80.08C113.789 77.181 107.687 71.3934 100.789 68.471C97.4089 67.0436 93.8729 66.3078 89.9651 66.911C85.5893 67.5948 81.9051 69.55 78.7851 72.2306C78.7435 72.2618 78.7098 72.306 78.6681 72.3372C75.1035 75.4364 72.2877 79.469 70.1089 83.5952C63.2371 96.5796 59.1447 113.256 58.7859 128.12V128.287C58.7859 128.955 58.7703 129.615 58.7703 130.276L58.6689 143.127Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5332 38.0824V42.0162H112.209V38.0824C112.209 37.7733 112.193 37.4642 112.159 37.1568C111.93 34.8946 110.868 32.7985 109.179 31.2754C107.491 29.7523 105.297 28.9109 103.023 28.9148H92.7008C91.4967 28.9141 90.3044 29.1509 89.1916 29.6114C88.079 30.0718 87.0682 30.7471 86.2169 31.5986C85.3654 32.4498 84.6902 33.4607 84.2297 34.5732C83.7693 35.686 83.5324 36.8784 83.5332 38.0824Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.964 158.6L126.937 168.612H151.897C152.246 168.612 152.592 168.543 152.914 168.409C153.237 168.276 153.53 168.079 153.776 167.832C154.273 167.329 154.554 166.652 154.556 165.945C154.555 165.334 154.343 164.742 153.957 164.268C153.571 163.795 153.033 163.469 152.435 163.345L141.101 161.023L139.599 155.277L122.964 158.6Z",
    fill: "#D7CB5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.642 240.807L150.582 229.887V222.453H137.247C137.186 222.454 137.128 222.472 137.076 222.503C137.025 222.535 136.983 222.579 136.955 222.632C136.927 222.685 136.913 222.744 136.915 222.804C136.918 222.864 136.936 222.923 136.968 222.973L152.36 245.289C152.715 245.803 153.189 246.223 153.742 246.514C154.295 246.804 154.91 246.956 155.535 246.956C156.249 246.956 156.949 246.758 157.558 246.384C158.166 246.01 158.659 245.475 158.981 244.837C159.303 244.2 159.442 243.486 159.382 242.774C159.322 242.063 159.066 241.381 158.642 240.807Z",
    fill: "#D7CB5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.654 47.7022C86.4156 50.1727 86.8038 52.7431 86.8058 55.328C92.4426 55.328 93.5034 52.5798 93.0692 50.4088C92.5856 47.996 93.311 44.629 96.6754 44.1454C100.04 43.6618 99.0908 48.9632 98.6904 55.2188C98.7008 56.5643 98.9229 57.8997 99.3482 59.176C99.9806 61.1018 101.306 62.7242 103.066 63.7286C104.746 64.6586 106.641 65.1279 108.56 65.0884C108.56 65.0884 111.849 56.9062 109.553 56.2302C107.257 55.5542 101.979 49.6834 103.181 42.4502C103.207 42.2916 103.233 42.1512 103.266 42.0082H84.8194C84.7778 43.9395 85.0599 45.8643 85.654 47.7022Z",
    fill: "#D7CB5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8039 128.128V128.295C58.8039 128.963 58.7883 129.623 58.7883 130.284L58.6973 143.159C58.6973 143.702 58.7129 144.238 58.7285 144.771",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7041 157.055C64.9804 160.605 68.1131 163.524 71.814 165.545C75.5146 167.566 79.6644 168.624 83.8811 168.62H130.161C134.462 168.62 136.599 170.757 136.599 173.389V242.06C136.599 243.359 137.115 244.606 138.034 245.525C138.953 246.444 140.2 246.961 141.5 246.961H158.423",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.642 240.807L150.582 229.887V222.453H137.247C137.186 222.454 137.128 222.472 137.076 222.503C137.025 222.535 136.983 222.579 136.955 222.632C136.927 222.685 136.913 222.744 136.915 222.804C136.918 222.864 136.936 222.923 136.968 222.973L152.36 245.289C152.715 245.803 153.189 246.223 153.742 246.514C154.295 246.804 154.91 246.956 155.535 246.956C156.249 246.956 156.949 246.758 157.558 246.384C158.166 246.01 158.659 245.475 158.981 244.837C159.303 244.2 159.442 243.486 159.382 242.774C159.322 242.063 159.066 241.381 158.642 240.807Z",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.584 142.412L116.854 143.205",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.127 148.617C159.133 152.886 165.547 163.366 164.226 174.681L158.691 222.454H136.591",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.088 128.679L114.286 136.739L116.849 143.211L122.964 158.6L126.937 168.613H151.897C152.246 168.613 152.592 168.544 152.915 168.41C153.237 168.276 153.53 168.08 153.777 167.833C154.274 167.33 154.554 166.652 154.557 165.945C154.555 165.334 154.344 164.742 153.957 164.269C153.571 163.795 153.034 163.469 152.435 163.345L141.102 161.023L139.599 155.277L149.895 153.431L148.135 148.614L133.211 107.794C130.091 99.2136 118.43 97.3702 111.818 103.667L111.433 104.034L69.6514 143.78",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1533 168.621C90.0619 168.621 93.8894 167.505 97.1854 165.405C100.481 163.304 103.109 160.306 104.759 156.762L111.581 142.418L114.285 136.74",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5643 89.2554C91.5643 89.2554 94.7467 96.4886 111.899 99.0678C113.927 99.378 116.153 99.612 118.578 99.7698C120.485 99.886 122.536 99.95 124.733 99.9622C144.833 100.03 153.468 103.134 156.817 104.965C157.008 105.07 157.225 105.124 157.444 105.121C157.663 105.117 157.877 105.057 158.066 104.946C158.255 104.835 158.412 104.676 158.521 104.486C158.63 104.296 158.688 104.081 158.689 103.862V96.5042C160.215 97.5234 161.335 99.034 162.144 100.747C163.155 102.827 163.704 105.23 163.998 107.427C164.237 109.162 164.352 110.912 164.341 112.663C164.341 113.095 164.512 113.509 164.817 113.815C164.966 113.969 165.145 114.091 165.343 114.174C165.541 114.257 165.754 114.3 165.969 114.299C166.355 114.3 166.729 114.163 167.024 113.915C167.319 113.665 167.516 113.32 167.581 112.939C168.361 108.337 169.902 93.2646 158.689 87.1858C156.349 85.9248 153.46 85.0486 149.885 84.7392C140.234 83.9046 129.628 83.9592 120.575 80.08C113.802 77.181 107.708 71.3856 100.815 68.471C97.4481 67.0436 93.8991 66.3078 89.9913 66.911C85.6155 67.5948 81.9313 69.55 78.8113 72.2306C75.1869 75.3506 72.3373 79.4274 70.1325 83.5952C63.2607 96.5796 59.1683 113.256 58.8095 128.12V128.287C58.8095 128.955 58.7939 129.615 58.7939 130.276",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3773 59.228L99.3539 59.176C98.8729 58.2192 98.5739 56.9374 98.6935 55.2214C99.0887 48.9606 100.053 43.6618 96.6811 44.1454C93.3089 44.629 92.5887 47.9986 93.0801 50.4062C93.5143 52.5798 92.4587 55.3462 86.8193 55.3306",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.554 56.2307C109.998 54.6031 113.854 54.8319 112.125 51.3063C111.14 49.2939 111.085 45.8645 111.704 42.0165",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8196 42.0165C84.7816 43.9447 85.063 45.8661 85.6516 47.7027C86.4173 50.173 86.8073 52.7446 86.8086 55.3311L86.715 59.8837C86.6848 61.9941 86.1443 64.0658 85.1397 65.9222C84.1348 67.7784 82.6959 69.3641 80.9456 70.5437C80.1344 71.0679 79.3768 71.6706 78.6836 72.3429",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6934 55.2214C98.7022 56.5664 98.925 57.9012 99.3538 59.176C101.561 65.4888 108.558 65.0858 108.558 65.0858C108.558 65.0858 111.852 56.9062 109.554 56.2302C107.255 55.5542 101.98 49.6834 103.184 42.4502C103.207 42.2968 103.238 42.1486 103.269 42.0082",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.231 37.1535H112.278",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.964 158.608L139.588 155.285",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.688 96.5037V87.1853",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.149 100.742C160.677 103.29 161.02 108.443 162.614 108.342C163.165 108.3 163.625 107.923 164.002 107.424",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.279 42.0157V38.0845C112.279 36.8794 112.041 35.686 111.58 34.5725C111.118 33.4591 110.442 32.4475 109.589 31.5957C108.737 30.7437 107.724 30.0682 106.611 29.6078C105.497 29.1473 104.303 28.9107 103.098 28.9117H92.776C91.5709 28.9107 90.3775 29.1473 89.2642 29.608C88.1506 30.0685 87.1389 30.744 86.2866 31.596C85.4344 32.448 84.7586 33.4597 84.2976 34.573C83.8367 35.6863 83.5998 36.8797 83.6006 38.0845V42.0157H122.533",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.569 42.016C104.751 31.3378 98.6694 29.1564 97.9414 28.9328C97.8951 28.9169 97.8447 28.9169 97.7984 28.9328C97.0704 29.1564 90.989 31.3378 91.171 42.016",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.926 28.86C99.907 28.3275 99.6822 27.8231 99.2989 27.4531C98.9154 27.0831 98.4035 26.8764 97.8707 26.8764C97.338 26.8764 96.8261 27.0831 96.4426 27.4531C96.0593 27.8231 95.8344 28.3275 95.8154 28.86H99.926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.067 63.7234L100.82 68.4684",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.988 46.0197C110.988 46.0197 107.481 45.3879 106.145 48.0997",
    stroke: "black",
    strokeWidth: 0.952,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.288 49.758C109.778 49.4166 109.94 48.8017 109.65 48.3847C109.359 47.9674 108.726 47.906 108.236 48.2477C107.746 48.5891 107.584 49.204 107.875 49.621C108.165 50.038 108.798 50.0994 109.288 49.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.444 56.8181C106.444 56.8181 107.778 58.6979 110.5 58.0271",
    stroke: "black",
    strokeWidth: 0.952,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0891 142.412C71.0891 142.412 63.4399 148.615 62.2673 159.79C61.7837 164.4 64.6853 168.617 69.3211 168.617H84.5285",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7754 165.788C63.7754 165.788 58.461 157.622 58.7002 141.348",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.423 104.044C111.674 102.393 111.833 100.729 111.899 99.06",
    stroke: "black",
    strokeWidth: 0.964,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3595 158.02C63.3595 158.02 63.0605 157.461 62.7043 158.244C62.3481 159.027 60.8999 165.49 65.3563 167.373C69.8127 169.255 79.1701 168.181 79.1701 168.181C79.1701 168.181 68.1201 165.836 63.3595 158.02Z",
    fill: "#AFAFAF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBuildingRelax);
export default __webpack_public_path__ + "static/media/man-building-relax.9c4fe51536b970a8ba6d5d29dff55cc6.svg";
export { ForwardRef as ReactComponent };